import { Timestamp } from "@firebase/firestore-types";

interface Role {
    title: string,
    userRights: number,
}

interface User {
    id: string;
    username: string;
    imageUrl: string;
    email: string;
    creationDate: number;
    createdAt: Timestamp;
    updatedAt: Timestamp;
    deletedAt?: Timestamp;
    role?: Role;
}

function hasRight(right: UserRight, user?: User): boolean {
    if (user === undefined || user === null) {
        return false;
    }
    if (user.role === null || user.role === undefined) return false;
    return (right & (user.role!.userRights)) !== 0;
}

function userHasRight(right: UserRight, userRights: number) {
    return (right & userRights) !== 0;
}

function getUserRights(rights: number): string {
    let rightsString: string = "";
    for (const right of Object.keys(allRights).map(k => parseInt(k))) {
        if ((right & (rights)) !== 0) {
            rightsString += `${allRights[right]}, `
        }
    }
    return rightsString;
}

enum UserRight {
    canCreatePost = 1 << 0,
    canDeletePost = 1 << 1,
    canUpdatePost = 1 << 2,
    canComment = 1 << 3,
    canUpdateComment = 1 << 4,
    canDeleteComment = 1 << 5,
    canLike = 1 << 6,
    canDislike = 1 << 7,
    canCreateUsers = 1 << 8,
    canUpdateUsers = 1 << 9,
    canDeleteUsers = 1 << 10,
    canDeleteOthersComments = 1 << 11,
    canDeleteOthersPosts = 1 << 12,
    canDeleteOthersLikes = 1 << 13,
    canDeleteOthersDislikes = 1 << 14,
    canSeeAllLikes = 1 << 15,
    canSeeAllDislikes = 1 << 16,
    canUpdatePortfolio = 1 << 17,
    canUpdateResume = 1 << 18,
    canUpdateContactMe = 1 << 19,
    canSeeAdminPanel = 1 << 20,
    zahra = 1 << 21,
}

export const allRights = {
    [UserRight.canCreatePost.valueOf()]: "canCreatePost",
    [UserRight.canDeletePost.valueOf()]: "canDeletePost",
    [UserRight.canUpdatePost.valueOf()]: "canUpdatePost",
    [UserRight.canComment.valueOf()]: "canComment",
    [UserRight.canUpdateComment.valueOf()]: "canUpdateComment",
    [UserRight.canDeleteComment.valueOf()]: "canDeleteComment",
    [UserRight.canLike.valueOf()]: "canLike",
    [UserRight.canDislike.valueOf()]: "canDislike",
    [UserRight.canCreateUsers.valueOf()]: "canCreateUsers",
    [UserRight.canUpdateUsers.valueOf()]: "canUpdateUsers",
    [UserRight.canDeleteUsers.valueOf()]: "canDeleteUsers",
    [UserRight.canDeleteOthersComments.valueOf()]: "canDeleteOthersComments",
    [UserRight.canDeleteOthersPosts.valueOf()]: "canDeleteOthersPosts",
    [UserRight.canDeleteOthersLikes.valueOf()]: "canDeleteOthersLikes",
    [UserRight.canDeleteOthersDislikes.valueOf()]: "canDeleteOthersDislikes",
    [UserRight.canSeeAllLikes.valueOf()]: "canSeeAllLikes",
    [UserRight.canSeeAllDislikes.valueOf()]: "canSeeAllDislikes",
    [UserRight.canUpdatePortfolio.valueOf()]: "canUpdatePortfolio",
    [UserRight.canUpdateResume.valueOf()]: "canUpdateResume",
    [UserRight.canUpdateContactMe.valueOf()]: "canUpdateContactMe",
    [UserRight.canSeeAdminPanel.valueOf()]: "canSeeAdminPanel",
    [UserRight.zahra.valueOf()]: "zahra",
}



export { UserRight, getUserRights, hasRight, userHasRight };
export type { Role, User };

